import { createContext } from 'react'
import type { Context } from 'react'
import type { RefferalStateType } from 'storeContext/reducers/referral/types'
import type { RefferalDispatchType } from 'storeContext/actions/refferal'

export type RefferalContextValueType = { state: RefferalStateType; dispatch: RefferalDispatchType }

// Preserve the existing raw-state default and Provider identity.
export const createRefferalContext = (initialState: RefferalStateType) =>
  createContext(initialState) as unknown as Context<RefferalContextValueType>
